import {NgModule} from '@angular/core';
import {PurchaseRoutingModule} from './purchase-routing.module';

@NgModule({
  imports: [
    PurchaseRoutingModule,
  ]
})


export class PurchaseModule {
}
